<div style="display: flex; flex-direction: column; justify-content: space-around">
    <p class="mat-body">{{ data.msg }}</p>
    <div style="display: flex; flex-direction: row; justify-content: flex-end;">
        <button mat-raised-button color="accent" (click)="dialogRef.close(false)" style="margin-right:15px;">No</button>
        <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Yes</button>
    </div>
</div>
